// src/assets/base.ts

// We use jsdelivr to load the pictures from the asset repository.
// This allows us to keep the main repository smaller and cleaner,
// while still being able to use binary assets.

// const ASSET_VERSION = "v1.0.0";

const CDN =
  `https://cdn.jsdelivr.net/gh/integralis-ry/site_binaries/`;

const images = (path) => `${CDN}/images/${path}`;
const icons = (path) => `${CDN}/icons/${path}`;
const documents = (path) => `${CDN}/documents/${path}`;

const board_path = "board/2026";

export const assets = {
  images: {
    board: {
      "2026": {
        aki: images(`${board_path}/aki.jpg`),
        aleksii: images(`${board_path}/aleksii.jpg`),
        andrejs: images(`${board_path}/andrejs.jpg`),
        antoine: images(`${board_path}/antoine.jpg`),
        cicek: images(`${board_path}/cicek.jpeg`),
        daniel: images(`${board_path}/daniel.jpg`),
        dasha: images(`${board_path}/dasha.jpg`),
        janne: images(`${board_path}/janne.jpg`),
        oliwia: images(`${board_path}/oliwia.jpg`),
        pradham: images(`${board_path}/pradham.png`),
        ruta: images(`${board_path}/ruta.jpg`),
        selma: images(`${board_path}/selma.jpg`)
      },
    },
    partnerships: {
      overalls_placement: images('/partnerships/overalls_placement.png')
    }, 
    patches: {
      csolive: images('patches/CSolive_patch.png'),
      freshersitsit25: images('patches/fresgersitsit2025_patch.png'),
      fresherventure: images('patches/fresheradventure_patch.png'),
      fresher23: images('patches/freshers2023_patch.png'),
      weball: images('patches/fuckitweball_patch.png'),
      halloween25: images('patches/halloween2025_patch.png'),
      intelogo: images('patches/integralislogo_patch.png'),
      iss1: images('patches/ISS_mission1__patch.png'),
      iss2: images('patches/ISS_mission2_patch.png'),
      iss3: images('patches/ISS_mission3_patch.png'),
      iss4: images('patches/ISS_mission4_patch.png'),
      mrworldwide: images('patches/mrworldwide_patch.png'),

      sisu: images('patches/sisu_patch.png'),
      springsitsit22: images('patches/springbreaksitsit2022_patch.png'),
      textolive: images('patches/text_art_olive_patch.png'),
      vappu25: images('patches/vappu2025_patch.png'),
      vappu26: images('patches/vappu2026_patch.png'),
      vujut25: images('patches/vujut2025_patch.png')
    }
  },

  icons: {
    site: {
      integralis_logo: icons(`site/IntegralisLogo.svg`),
      kide_app: icons(`site/Kide-App-PURPLE-1280x.svg`),
      alert: icons(`site/alert.svg`),
      bill: icons(`site/bill-8853.svg`),  
      bug: icons(`site/bug_1.svg`),
      chemistry: icons(`site/chemistry.svg`),
      earth: icons(`site/earth.svg`),
      geometry: icons(`site/geometry_1.svg`),
      graduation: icons(`site/graduation_1.svg`),
      instagram: icons(`site/instagram.svg`),
      money: icons(`site/money.svg`),
      physics: icons(`site/physics.svg`),
      sharepoint_logotype: icons(`site/sharepoint-logotype.svg`),
      signpost: icons(`site/signpost.svg`),
      telegram: icons(`site/telegram.svg`),
    },

    sponsors: {
      accenture: icons(`sponsors/accenture_logo.png`),
      loimu: icons(`sponsors/loimu.png`),
      tek: icons(`sponsors/TEK.png`),
      laplandtravels: icons('sponsors/LAPLANDTRAVELS.png')
    },

    
  },

  documents: {
    equality_plan: documents("Equality Plan 2026.pdf"),
    safe_space_principles: documents("Safe Space Principles 2026.pdf"),
    official_rules_eng: documents("[ENG] Rules.pdf"),
    official_rules_fin: documents("[FIN] Official Rules.pdf"),
    environmental_plan: documents("Environmental Plan 2025.pdf"),
    partnership_options: documents("Partnership Options 2026.pdf"), 
    fresher_guide: documents("Fresher_guide.pdf"),
    study_guide: documents("2026_Study_Guide_period_2.pdf")
  },
};
